import { FadeIn } from '../../components/AnimateIn'
import Section from '../../components/Section'
import { Text } from '../../components/Text'
import Announcement from './Announcement'

export default function AnnouncementsPreview() {
  return (
    <Section withVerticalPadding className='bg-neutral-100'>
      <div className='flex flex-col w-full gap-[44px]'>
        <FadeIn>
          <Text.H2>Announcements</Text.H2>
        </FadeIn>
        <div className='flex flex-col lg:flex-row gap-[60px] transition-all'>
          <FadeIn delay={0.2} className='flex w-full lg:flex-1'>
            <Announcement
              title='Worship Meeting with Breaking of Bread'
              every='Upcoming Sunday'
              time='4pm'
              highlighted
            >
              Sunday service starts at 4pm and ends at 6pm. Session consists of songs, thoughts
              related to table, praise and worship, breaking of bread and word ministry. Meeting
              ends with announcements by one of the leading members of the church.
            </Announcement>
          </FadeIn>
          <FadeIn delay={0.4} className='flex w-full lg:flex-1'>
            <Announcement
              title='Weekly Bible Study and Prayer Meeting'
              every='Wednesday'
              time='8:30pm'
            >
              We gather every Wednesday at 8:30pm to 10:30pm for Bible Study on 1st three Wednesdays
              of the month and for prayer for the last Wednesday of the month. We take various
              biblical books for our regular study. The study consists of participation from all
              members of the church, each member of the church is encouraged to contribute from the
              passage selected for study that week.
            </Announcement>
          </FadeIn>
          <FadeIn delay={0.6} className='flex w-full lg:flex-1'>
            <Announcement
              title='Sunday School and Gospel/Testimony Meeting'
              every='Saturday'
              time='6:45pm'
            >
              We gather every Saturday at 6:45pm to 8:15pm for Sunday school. From 8:15pm to 9:30pm
              is the session for Gospel Meeting on the 1st three Saturdays of the month and on the
              last Saturday, we have Testimony meetings. Youth meetings are arranged intermediately
              in alternate month. Sister’s Meeting and council meeting are also held in locations
              pre-decided.
            </Announcement>
          </FadeIn>
        </div>
      </div>
    </Section>
  )
}
